import './_quick-shop-product-form.scss';
import component from './quick-shop-product-form';

export default component;
